/**
 * This Slice manages data related to Salesforce CDP.
 */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MetadataResponse } from '../../../server/cdp/types';

export interface CdpState {
    metadata: MetadataResponse | null;
    metadataStatus: string;
}

const initialState: CdpState = {
    metadata: null,
    metadataStatus: 'idle',
};

export const cdpSlice = createSlice({
    name: 'cdp',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchMetadata.pending, (state, action) => {
                state.metadataStatus = 'loading';
            })
            .addCase(fetchMetadata.fulfilled, (state, action) => {
                state.metadataStatus = 'succeeded';
                state.metadata = action.payload;
            })
            .addCase(fetchMetadata.rejected, (state, action) => {
                state.metadataStatus = 'failed';
            });
    },
});

export const {} = cdpSlice.actions;

export const fetchMetadata = createAsyncThunk('cdp/fetchMetadata', async () => {
    const response = await fetch('/modules/cdp-refresh/fetchMetadata');
    return await response.json();
});
